<template>
  <Popup
    class="select-city-popup"
    :show="show"
    v-bind="$attrs"
    closeable
    position="bottom"
    style="width: 100vw; height: 100vh"
    teleport="body"
    :z-index="5000"
  >
    <IndexBar :index-list="keys" :sticky-offset-top="0" :z-index="2004">
      <Cell v-if="currentCity" :title="currentCity" class="selected-city">
        <template #icon> <span class="sprite-location"></span> </template>
      </Cell>
      <Skeleton :row="20" :loading="!list">
        <template v-if="list">
          <template v-for="(item, key) in list" :key="key">
            <IndexAnchor :index="key" />
            <template v-for="(cname, i) in item" :key="i">
              <Cell
                :title="cname.v"
                @click="
                  $emit('update:currentCity', cname.v),
                    $emit('change', cname),
                    $emit('update:show', false)
                "
              />
            </template>
          </template>
        </template>
      </Skeleton>
    </IndexBar>
  </Popup>
</template>

<script lang="ts">
import { defineComponent, shallowReactive, toRefs, watch } from 'vue'
import { IndexBar, IndexAnchor, Cell, Skeleton, Toast, Popup } from 'vant'
import { request } from '@/utils/request'

interface RootObject {
  code: number
  entry: Entry
  msg: string
}

interface Entry {
  data: Data
}

type Data = Record<
  string,
  {
    k: string
    v: string
  }[]
>

const getData = async (url: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<RootObject>(url)
    if (code == 0) {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}

export default defineComponent({
  name: 'SelectCity',
  components: {
    Popup,
    Cell,
    IndexBar,
    IndexAnchor,
    Skeleton
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    currentCity: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const res = shallowReactive<{ keys: string[]; list: Data | null }>({
      keys: [],
      list: null
    })
    const unwatch = watch(
      () => props.show,
      async v => {
        if (!v) return
        unwatch()
        const data = await getData(props.url)
        if (data) {
          res.keys = Object.keys(data)
          res.list = data
        }
      }
    )
    return {
      ...toRefs(res)
    }
  }
})
</script>

<style lang="scss">
.select-city-popup {
  .van-popup__close-icon {
    position: fixed;
    z-index: 2004;
  }
}
</style>
<style lang="scss" scoped>
.selected-city {
  align-items: center;
  .sprite-location {
    margin-right: 4px;
  }
  &::after {
    border: none;
  }
}
</style>
